// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chats-solid';

export const Component = () => (
  <path d='M6.37 17.673h7.375l3.928 2.92H10.44L5.508 24.33c-.24.143-.48.191-.623.191a.946.946 0 0 1-.67-.287.976.976 0 0 1-.288-.72v-2.92H1.485c-.431 0-.766-.144-1.054-.431A1.408 1.408 0 0 1 0 19.109V5.41c0-.431.144-.766.431-1.054a1.408 1.408 0 0 1 1.054-.431h2.442V15.18c0 .72.24 1.293.72 1.772.479.48 1.053.72 1.723.72ZM23.037 0H6.37c-.43 0-.766.144-1.054.431a1.408 1.408 0 0 0-.43 1.054v13.698c0 .431.143.766.43 1.054.288.287.623.431 1.054.431h7.711l4.933 3.736c.24.144.479.191.623.191a.946.946 0 0 0 .67-.287.946.946 0 0 0 .288-.67v-2.97h2.442c.431 0 .766-.144 1.054-.431a1.41 1.41 0 0 0 .43-1.054V1.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 0Z' />
);

export const viewBox = '0 0 25 25';
